/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';
import type { Smartlist, FindSmartlistParams, SmartlistItem } from 'types';

const find = async (params: FindSmartlistParams): Promise<Smartlist[]> => {
  const endpoint = params.parentId
    ? '/protones-portlet.smartlists/find-children-and-unlock-by-user'
    : '/protones-portlet.smartlists/find-and-unlock-by-user';
  const response = await callLiferayEndpoint(endpoint, {
    parentSmartlistId: params.parentId,
    ...(params.pagination || {}),
  });
  // ignoro dati aggiuntivi della risposta e prendo il primo elemento di un array (con un unico elemento)
  const results = response.map(utils.toSmartlist);
  return results;
};

const get = async (id: number): Promise<Smartlist> => {
  const endpoint = '/protones-portlet.smartlists/get';
  const response = await callLiferayEndpoint(endpoint, { smartlistId: id });
  return utils.toSmartlist(response);
};

const findItems = async (id: number): Promise<SmartlistItem[]> => {
  const endpoint = '/protones-portlet.smartlists/get-smartlist-items';
  const response = await callLiferayEndpoint(endpoint, { smartlistId: id });
  return response.map(utils.toSmartlistItem);
};

export default {
  find,
  get,
  items: { find: findItems },
};
